// The one pager of the Insights pages (N5 pt 4): 'Showing 1 to 10 of 25', the page numbers and Next, as Search
// Intelligence has it, under each table on Search Intelligence, Content Health and the compliance page. page counts
// from 1.
import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme';

const T = tokens;

const InsightsPager = ({ page, total, perPage, onChange }) => {
  const totalPages = Math.ceil(total / perPage);
  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '12px 18px', borderTop: `0.5px solid ${T.color.borderTertiary}`, flexWrap: 'wrap' }}>
      {/* 'Showing 1 to 10 of 25', no dash between the numbers (K3 pt 17), as every table's page count (K2.1 pt 2.1). */}
      <Typography sx={{ fontSize: T.font.size.sm, color: T.color.textSecondary, marginRight: '8px', fontFamily: T.font.family }}>Showing {start} to {end} of {total}</Typography>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
        <Box key={p} onClick={() => onChange(p)} sx={{ fontSize: T.font.size.sm, color: p === page ? T.color.textPrimary : T.color.textSecondary, background: p === page ? T.color.bgSecondary : 'transparent', border: `0.5px solid ${p === page ? T.color.borderSecondary : T.color.borderTertiary}`, borderRadius: T.radius.sm, padding: '4px 10px', cursor: 'pointer', fontFamily: T.font.family }}>
          {p}
        </Box>
      ))}
      {page < totalPages && <Box onClick={() => onChange(page + 1)} sx={{ fontSize: T.font.size.sm, color: T.color.textSecondary, border: `0.5px solid ${T.color.borderTertiary}`, borderRadius: T.radius.sm, padding: '4px 10px', cursor: 'pointer', fontFamily: T.font.family }}>Next →</Box>}
    </Box>
  );
};

export default InsightsPager;
